
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Punetopanindian() {



    const cardData =
    {
        keyword: 'Pune to Pan India Bus Service Amruta Travels',
        heading: 'Amruta Travels: Pune to Pan India Bus Service Amruta Travels',
        headingDescription: 'Amruta Travels offers Pune to Pan India Bus Service, connecting you seamlessly to destinations across the country with comfort, safety, and reliability. Whether it as a corporate tour, school/college trip, wedding group travel, or pilgrimage, our fleet of AC and non-AC buses is well-equipped to handle long-distance journeys. With professionally trained drivers, flexible routes, and 24/7 service support, Amruta Travels ensures a smooth and secure travel experience from Pune to any major city or town across India.',


        top: 'Top Places to Visit in Outstation Pune with Amruta Travels',


  "topPlaces": [
    {
      "title": "Mahabaleshwar",
      "description": "Located around 120 km from Pune, Mahabaleshwar is a picturesque hill station in the Western Ghats, known for its cool climate, evergreen forests, and stunning viewpoints such as Arthur’s Seat, Wilson Point (the highest point), and Kate's Point. The region is famous for its strawberry farms, especially during the Strawberry Festival held in spring. Other attractions include Venna Lake for boating, Mapro Garden for strawberry-based treats, and ancient temples like Panchganga and Mahabaleshwar Temple. It's a popular destination for families, honeymooners, and nature enthusiasts seeking a refreshing escape from city life."
    },
    {
      "title": "Lonavala & Khandala",
      "description": "Just 66 km from Pune, these twin hill stations in the Sahyadri range offer a perfect blend of natural beauty and adventure. Lonavala is known for its misty mountains, lush greenery, and monsoon waterfalls like Kune and Bhivpuri. Attractions include Bhushi Dam, Tiger’s Leap, Rajmachi Fort, and Karla & Bhaja Caves. Khandala is equally famous for its panoramic valley views and trekking routes. The area is ideal for a weekend drive, with scenic routes and roadside chikki stalls that add to the charm of this quick getaway."
    },
    {
      "title": "Shirdi",
      "description": "About 190 km from Pune, Shirdi is a sacred town revered by followers of Sai Baba. The Sai Baba Samadhi Mandir is the main attraction, drawing millions of devotees every year. Pilgrims can also visit Dwarkamai, Chavadi, and the Sai Heritage Village. The spiritual ambiance, combined with well-maintained infrastructure and religious events, makes Shirdi a prominent destination for those seeking peace, healing, and spiritual growth."
    },
    {
      "title": "Goa",
      "description": "Located nearly 450 km from Pune, Goa is India’s premier beach destination, known for its lively culture, golden beaches, and Portuguese heritage. From North Goa’s party hotspots like Baga, Anjuna, and Calangute to South Goa’s serene stretches like Palolem and Colva, there’s a vibe for every traveler. Apart from beaches, visitors can explore Aguada Fort, Basilica of Bom Jesus, spice plantations, vibrant flea markets, and indulge in thrilling water sports. Goa is also a haven for foodies, offering authentic seafood, Goan curries, and beachside shacks serving refreshing cocktails."
    },
    {
      "title": "Nashik",
      "description": "Around 210 km from Pune, Nashik is a city of immense cultural, historical, and spiritual significance. It is one of the four cities where the Kumbh Mela is held. Attractions include the ancient Kalaram Temple, Muktidham Temple, Pandavleni Caves, and Trimbakeshwar Temple—an important Jyotirlinga. Nashik is also the wine capital of India, home to Sula Vineyards, York Winery, and many tasting tours. The Godavari River adds to its charm, making it a harmonious blend of spirituality and leisure tourism."
    },
    {
      "title": "Alibaug",
      "description": "Situated about 140 km from Pune, Alibaug is a tranquil coastal town offering a perfect mix of beaches, history, and nature. Popular beaches include Nagaon, Alibaug Beach, and Kashid Beach, all great for swimming, sunbathing, and water sports. The iconic Kolaba Fort, accessible during low tide, adds historical value to the destination. You can also explore Korlai Fort, Kanakeshwar Temple, and local seafood cuisine. Ideal for weekend trips, Alibaug also offers ferry services from Mumbai for added convenience."
    },
    {
      "title": "Kolhapur",
      "description": "Roughly 235 km from Pune, Kolhapur is a vibrant city known for its divine Mahalaxmi Temple, which draws pilgrims throughout the year. The city is equally famous for its spicy cuisine, Kolhapuri chappals, and traditional arts. Attractions include Rankala Lake for evening strolls, Panhala Fort offering panoramic views, and the New Palace Museum showcasing royal heritage. With its rich cultural identity and warm hospitality, Kolhapur is ideal for heritage and culinary tourism."
    },
    {
      "title": "Lavasa",
      "description": "Just 60 km from Pune, Lavasa is an Italian-inspired planned city nestled in the Sahyadri hills. It features beautiful waterfronts, European-style architecture, and a peaceful atmosphere perfect for a quick weekend escape. Activities include kayaking, zip-lining, and lakeside cycling. With cozy resorts, conference centers, and nature trails, Lavasa attracts both families and corporate travelers. The weather remains pleasant most of the year, enhancing its appeal as a rejuvenating destination close to Pune."
    },
    {
      "title": "Satara & Kaas Plateau",
      "description": "About 120 km from Pune, Satara serves as the base for exploring the Kaas Plateau—popularly known as the 'Valley of Flowers' of Maharashtra. The plateau, a UNESCO World Natural Heritage site, bursts into a riot of colors with over 850 species of wildflowers during the monsoon season. Satara is also known for Ajinkyatara Fort, Thoseghar Waterfalls, and Sajjangad Fort. The natural beauty and biodiversity make this region a paradise for trekkers, botanists, and photographers."
    },
    {
      "title": "Aurangabad",
      "description": "Situated 235 km from Pune, Aurangabad is a historical treasure trove, offering insights into ancient art, architecture, and culture. The city is home to the world-famous Ajanta and Ellora Caves, adorned with exquisite carvings and paintings dating back to 2nd century BCE. Other attractions include Bibi Ka Maqbara (a replica of the Taj Mahal), Daulatabad Fort, and Aurangabad Caves. The city is also a gateway to Grishneshwar Jyotirlinga and Paithani saree shopping, making it a must-visit for heritage lovers."
    }
  ],

     "services": [
    {
      "name": "Amruta Travels Bus Hire Pan India",
      "description": "Amruta Travels offers comprehensive bus rental services across India, catering to various travel needs including corporate events, family functions, pilgrimages, and leisure tours. Our fleet includes a range of buses from 25 to 57 seats, ensuring comfort and convenience for all passengers."
    },
    {
      "name": "Pune to India-wide Bus Rental",
      "description": "We provide reliable and affordable bus rental services from Pune to destinations across India. Whether it's a corporate trip, family outing, or religious tour, we have the right vehicle to suit your needs."
    },
    {
      "name": "Long-Distance Luxury Bus Hire",
      "description": "Experience comfort on long-distance journeys with our luxury buses. Equipped with modern amenities like Wi-Fi, charging points, and plush seating, our buses ensure a pleasant travel experience."
    },
    {
      "name": "Pan India Corporate Bus Services",
      "description": "Amruta Travels offers tailored bus rental solutions for corporate events, conferences, and team outings across India. Our professional drivers and well-maintained buses ensure timely and safe transportation."
    },
    {
      "name": "Group Bus from Pune to Any City",
      "description": "Organize group trips from Pune to any city in India with our spacious buses. We accommodate various group sizes and provide customized packages to meet your specific requirements."
    },
    {
      "name": "Wedding Bus Pan India Tour",
      "description": "Make your wedding celebrations memorable with our wedding bus services. We offer transportation for guests to and from wedding venues across India, ensuring comfort and punctuality."
    },
    {
      "name": "Bharat Benz Bus Across India",
      "description": "Travel in style with our Bharat Benz buses, available for hire across India. Known for their luxury and performance, these buses are ideal for long-distance and corporate travel."
    },
    {
      "name": "Volvo Bus Inter-State Tour",
      "description": "Our Volvo buses are perfect for inter-state tours, offering superior comfort and safety. With features like reclining seats and air conditioning, they are suitable for both leisure and business trips."
    },
    {
      "name": "Outstation Bus for Any City",
      "description": "We provide outstation bus services from Pune to any city in India. Whether it's a short trip or a long journey, our buses are equipped to handle all your travel needs."
    },
    {
      "name": "Long Route Event Bus Pune",
      "description": "Plan your events with ease using our long-route event bus services. We offer transportation for conferences, exhibitions, and other events, ensuring timely arrivals and departures."
    },
    {
      "name": "Staff Transport Bus Across India",
      "description": "Amruta Travels offers staff transport solutions across India, ensuring safe and punctual transportation for your employees. Our buses are equipped with necessary amenities for a comfortable journey."
    },
    {
      "name": "Multi-State Bus Rental Pune",
      "description": "We offer multi-state bus rental services from Pune, catering to various destinations across India. Our fleet includes a range of buses to suit different group sizes and travel requirements."
    },
    {
      "name": "AC Coach Pan India Service",
      "description": "Travel in comfort with our AC coaches, available for hire across India. Equipped with modern amenities, our coaches ensure a pleasant travel experience for all passengers."
    },
    {
      "name": "Executive Group Bus Pan India",
      "description": "Our executive group buses are designed for business travel across India. With features like Wi-Fi, charging points, and comfortable seating, they are ideal for corporate outings and conferences."
    },
    {
      "name": "Amruta Intercity Tour Bus",
      "description": "Explore cities with our intercity tour bus services. We offer transportation between cities across India, ensuring comfort and convenience for all passengers."
    }
  ],
  "tableData": [
    ["Amruta Travels Bus Hire Pan India", "Pune to India-wide Bus Rental"],
    ["Long-Distance Luxury Bus Hire", "Pan India Corporate Bus Services"],
    ["Group Bus from Pune to Any City", "Wedding Bus Pan India Tour"],
    ["Bharat Benz Bus Across India", "Volvo Bus Inter-State Tour"],
    ["Outstation Bus for Any City", "Long Route Event Bus Pune"],
    ["Staff Transport Bus Across India", "Multi-State Bus Rental Pune"],
    ["AC Coach Pan India Service", "Executive Group Bus Pan India"],
    ["Amruta Intercity Tour Bus"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Pan India Bus Service – Amruta Travels",
    "WhyChoosedescription": "Amruta Travels proudly offers reliable and comfortable bus services from Pune to destinations across India. Whether it's a corporate tour, family trip, religious journey, or educational tour, our all-India coverage ensures smooth travel experiences for groups of any size."
  },
  {
    "WhyChooseheading": "Nationwide Connectivity for Every Travel Need",
    "WhyChoosedescription": "From Pune to Mumbai, Goa, Hyderabad, Bangalore, Delhi, Rajasthan, Gujarat, and beyond—Amruta Travels connects you to major cities and towns across India with well-planned routes and dependable service for long-distance group travel."
  },
  {
    "WhyChooseheading": "Comfortable and AC Buses for Long Journeys",
    "WhyChoosedescription": "Our fleet includes AC luxury buses with pushback seats, spacious interiors, ample legroom, and entertainment systems to make long-distance travel relaxing and enjoyable, even on overnight routes across India."
  },
  {
    "WhyChooseheading": "Perfect for Corporate, Pilgrimage, and Group Tours",
    "WhyChoosedescription": "Whether you're organizing a pan-India corporate tour, Char Dham Yatra, Jyotirlinga Darshan, school trip, or wedding group transport, our services are tailored to meet the unique travel needs of all group types and sizes."
  },
  {
    "WhyChooseheading": "Professional Drivers with Inter-State Route Expertise",
    "WhyChoosedescription": "Our drivers are experienced in inter-state travel, ensuring safe, timely, and smooth journeys across long distances. They are trained to handle extended routes while maintaining comfort and passenger safety throughout."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Amruta Travels offers clear, all-inclusive pricing for pan-India routes. Fuel, tolls, taxes, and driver allowances are covered in the quoted rates—helping you budget confidently without any last-minute surprises."
  },
  {
    "WhyChooseheading": "Custom Routes and Flexible Itineraries",
    "WhyChoosedescription": "We provide fully customizable routes and travel schedules. Whether you need multi-city transport, specific stopovers, or unique pickup/drop arrangements, our services are built around your itinerary and convenience."
  },
  {
    "WhyChooseheading": "24/7 Booking Assistance and Travel Support",
    "WhyChoosedescription": "Our dedicated customer support team is available around the clock to help with bookings, route planning, real-time updates, and assistance during travel. Booking your pan-India bus journey from Pune has never been easier."
  }
]




























    }

const faqData = [
  {
    question: 'Does Amruta Travels provide bus service from Pune to destinations across India?',
    answer: 'Yes, Amruta Travels offers long-distance bus rental services from Pune to various locations across India. Whether it’s a pilgrimage, educational tour, wedding transport, or corporate trip, we provide reliable and comfortable buses for interstate travel.',
  },
  {
    question: 'What types of buses are available for Pan India travel?',
    answer: 'We offer a wide range of buses for Pan India travel, including 24-seater, 32-seater, 36-seater, 45-seater, and 53-seater options in Tata, Bharat Benz, and Volvo categories. AC and luxury variants are available depending on group size and comfort preferences.',
  },
  {
    question: 'Is a driver included in the bus service for Pan India travel?',
    answer: 'Yes, all our interstate bus rentals include experienced, licensed drivers who are well-versed with long-distance travel. They ensure your journey is safe, punctual, and hassle-free across states and cities.',
  },
  {
    question: 'What are the amenities provided in buses for long-distance travel?',
    answer: 'Our long-distance buses feature air conditioning, pushback or reclining seats, spacious legroom, overhead storage, mobile charging ports, clean interiors, and entertainment systems. Premium luxury buses may also include Wi-Fi and individual reading lights.',
  },
  {
    question: 'Are Amruta Travels buses safe and well-maintained for interstate travel?',
    answer: 'Absolutely. All our buses undergo routine maintenance and are sanitized before every journey. We follow strict safety protocols and ensure every trip complies with national transport regulations.',
  },
  {
    question: 'How is the cost calculated for Pune to Pan India bus rentals?',
    answer: 'Pricing depends on distance, destination, trip duration, bus type, tolls, and driver allowance. Rates generally range between ₹30–₹50 per km. Contact us with your travel plan for a personalized quote.',
  },
  {
    question: 'How do I book a Pan India bus service from Pune?',
    answer: 'Booking is easy through our website or by contacting our customer service. Just share your destination, travel dates, and group size, and our team will assist you with quick booking, route planning, and competitive pricing.',
  },
];

const testimonialsData = [
  {
    id: 1,
    name: 'Mr. Sameer Wagh',
    role: 'Tour Manager, Pune',
    text: 'We hired a 53-seater bus from Amruta Travels for a 5-day South India tour starting from Pune. The bus was excellent, the journey was smooth, and the driver was extremely professional. Highly reliable for long routes.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Mrs. Anuja Bhagat',
    role: 'Wedding Coordinator',
    text: 'Amruta Travels helped us manage guest transport for a wedding with travel from Pune to Indore. Their 45-seater AC bus was clean, comfortable, and punctual. Fantastic coordination and support from their team!',
    rating: 5,
  },
];



































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7353109555",
            "+91 7090597555",
            "+91 7887774499",

        ],
        email: "booking@bushireinpune.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Bus Hire For Wedding in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Buses For Corporate Events",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "25 Seater Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "32 Seater Bus Rent in Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "35 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "45 Seater Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "50 Seater Bus On Rent in Pune",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Shirdi Bus Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Bus Rentals For School Trips in Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Bus booking for wedding in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Bus Booking for Marriage",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Bus Service for Corporate Pune",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Bus on Rent For Event in Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Bus Rental for Tour Packages",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Bus Hire for Outstation",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " AC Bus On Rent in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: " Pune Bus Hire Rental Service",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Bus Service for Picnic in Pune ",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Non Ac Bus Rental Service in Pune",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Luxury Bus Rental in Pune",
        },

        {
            place: "/images/keyword/22.jpg",
            text: "Luxury Force Urbania On Rent in Pune ",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Bhimashankar Jyotirlinga Bus Hire in Pune ",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Alibaug Bus on Rent",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune to Ganpatipule Beach Bus Rental Service ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to 5 Jyotirlinga Darshan Bus Hire",
        },
    ];


    const images = [
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/28.jpg", alt: "Image 1" },
        { src: "/images/gallery/2.jpg", alt: "Image 1" },
        { src: "/images/gallery/3.jpg", alt: "Image 1" },
        { src: "/images/gallery/24.jpg", alt: "Image 1" },
        { src: "/images/gallery/27.jpg", alt: "Image 1" },
        { src: "/images/gallery/29.jpg", alt: "Image 1" },
        { src: "/images/gallery/30.jpg", alt: "Image 1" },
        { src: "/images/gallery/31.jpg", alt: "Image 1" },

    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Pan India Bus Service – Amruta Travels",
  "image": "https://bushireinpune.com/assets/images/pune-to-pan-india-bus-service.jpg",
  "description": "Amruta Travels offers Pan India Bus Service from Pune, providing luxury AC buses including Volvo and Bharat Benz for long-distance travel across India. Ideal for corporate tours, weddings, events, intercity group transport, and multi-state journeys. Hire 25 to 50-seater buses for comfortable and reliable travel from Pune to any city nationwide.",
  "brand": {
    "@type": "Brand",
    "name": "Amruta Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "12350"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "48000",
    "availability": "https://schema.org/InStock",
    "url": "https://bushireinpune.com/pune-to-pan-india-bus-service"
  }
};






    return (
        <div>

<Helmet>
  <title>Call: +91 7353109555 | Pune to Pan India Bus Service | Intercity Luxury Bus Hire – Amruta Travels</title>
  <meta 
    name="description" 
    content="Book Pune to Pan India bus service with Amruta Travels. Hire AC luxury buses like Volvo and Bharat Benz for long-distance corporate tours, weddings, group events, and intercity travel across India." 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="breadcrumb-outer text-center">
                <div className="container">
                    <div className="breadcrumb-content">
                        <h2 className="white text-center">{cardData.keyword} </h2>
                    </div>
                </div>
                <div className="overlay"></div>
            </section>





            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                {/* <h1 className='text-white'>{cardData.keyword}</h1> */}
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Amruta Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <FAQKeyword faqs={faqData} />


                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword
                                title="Testimonial"
                                description="Hear what our happy customers have to say about their travel experience with Amruta Travels."
                                reviews={testimonialsData}
                            />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #021B3A',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#021B3A' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk text-white">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+917353109555" className="d-block  text-white">+91 7353109555</a>
                                                <a href="tel:+917090597555" className="d-block  text-white">+91 7090597555</a>
                                                <a href="tel:+917887774499" className="d-block  text-white">+91 7887774499</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Email</h4>
                                                <a href="mailto:booking@bushireinpune.com" className=" text-white d-block">
                                                    booking@bushireinpune.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#021B3A' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk text-white">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Amruta Travels <br />
                                                        Office No.- 2, Ground Floor, Wings H-(Puram), Prayeja City, Phase-2, Near Prayeja City, Vadgaon Budruk, Pune, Maharashtra - 411041
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetopanindian;